// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import SpinePlayer from '../../../../components/SpinePlayer';
import { BoomAssetsBySkinId } from '../../constants/assets';
import { useBoomContext } from '../../contexts/BoomContext';
import { useBoomHomeContext } from '../../contexts/BoomHomeContext';
import BoomHeaderContainer from '../BoomHeader/BoomHeaderContainer';
import BoomNotificationContainer from '../BoomNotification/BoomNotificationContainer';
import BoomStepperContainer from '../BoomStepper/BoomStepperContainer';
import BoomViewWrapper from '../BoomViewWrapper';
import BoomWelcomeContainer from '../BoomWelcome/BoomWelcomeContainer';
import BoomItem from '../common/BoomItem';

const StyledBoomViewWrapper = styled(BoomViewWrapper)`
  height: 100%;

  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledSpinePlayer = styled(SpinePlayer)`
  z-index: -1;

  ${Target.__MOBILE__
    ? css`
        top: 12em;
        transform: scale(1.5);
      `
    : css`
        top: 6em;
        transform: scale(1.2);
      `};
`;

type BoomHomeProps = {
  className?: string;
  isCompleted?: boolean;
};

const BoomHome = ({ className = '', isCompleted = false }: BoomHomeProps) => {
  const { nbWonSteps } = useBoomHomeContext();
  const { skinId } = useBoomContext();

  return (
    <StyledBoomViewWrapper className={className}>
      <Wrapper data-testid={'boom-home'}>
        <BoomHeaderContainer />
        {isCompleted ? (
          <StyledSpinePlayer animationId={BoomAssetsBySkinId[skinId]?.CompletedAnimation} scale={0.25} hideMuteButton />
        ) : (
          <BoomItem skinId={skinId} nbWonSteps={nbWonSteps} showAnimation={true} />
        )}
        <BoomStepperContainer />
      </Wrapper>
      <BoomWelcomeContainer />
      <BoomNotificationContainer />
    </StyledBoomViewWrapper>
  );
};

export default BoomHome;
